import store from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('SET_BE_SERVER', (beServer: string) => {
    store.xBEServer = beServer ?? '';
});
